module.exports = __webpack_public_path__ + "static/img/promote001.b5439de.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/promote001.jpeg
// module id = prh+
// module chunks = 1